import { defineStore } from 'pinia'
import {ref, unref, computed, reactive, toRaw} from 'vue'

import country_a2 from '@/tourist/country_a2.js'

import {suite_init, suite_remove, suite_setob, suite_getres} from '@/tourist/suite.js'
import {_get, findLast} from '@/actions.js'
import {save_localStorage} from '@/localStor.js'


const uid_func = ( prefix ) => () => {
    const d = Date.now() % Math.pow(2,25) + Math.round( Math.random() * Math.pow(2,25) )
    const n = d.toString(36)
    return `${prefix}.${n}`
}
const create_id = uid_func('t')

export const TSTORE_TYPE_CRUISE='TSTORE_TYPE_CRUISE'

const TOURIST={
    FIELDS: [],
    FIELDS_CUSTOMER: [],
    NAME: '',
    INITED: '',
    TYPES: [],
    GETTERS: {},
}

const TURISTNAME={
    gost: 'Гость',
    passazhir: 'Пассажир',
}

export const STATUS_ADL = 1
export const STATUS_CHD = 2
export const STATUS_INF = 3
// будем определять по возрасту или как-то еще - это ребенок или взрослый
// нужно чтобы безпрепятственно тусовать туристов с местом
// определяем по возрасту и все условно. При брони главное - дата рождения
export const STATUS_PLACE = -1 

export const CRUISE_OPTYPE_ADULT = 'CRUISE_OPTYPE_ADULT'
export const CRUISE_OPTYPE_CHILD = 'CRUISE_OPTYPE_CHILD'
export const CRUISE_OPTYPE_INFANT = 'CRUISE_OPTYPE_INFANT'
export const CRUISE_OPTYPE_PLACE = 'CRUISE_OPTYPE_PLACE'


export const CRUISE_ADULT={ id: 'cr-adult', optype: CRUISE_OPTYPE_ADULT, status:  STATUS_ADL, name: 'Взрослый'}
export const CRUISE_CHILD={ id: 'cr-child', optype: CRUISE_OPTYPE_CHILD, status:  STATUS_CHD, name: 'Ребенок на отдельном месте'}
export const CRUISE_INFANT={ id: 'cr-infant', optype: CRUISE_OPTYPE_INFANT, status:  STATUS_INF, name: 'Ребенок без места / питания'}
export const CRUISE_PLACE={ id: 'cr-place', optype: CRUISE_OPTYPE_PLACE, status:  STATUS_ADL, name: 'С местом'}

const TTNAMES = Object.fromEntries(
    [ CRUISE_ADULT, CRUISE_CHILD, CRUISE_INFANT, CRUISE_PLACE ].map( (all) => [all.id, all] )
)

export const ttname_by_id = id => {
    return TTNAMES[ id ] ? TTNAMES[ id ].name  : '---'
}
export const ttype_by_id = id => {
    return TTNAMES[ id ]
}


export const INPUT_TEXT='INPUT_TEXT'
export const INPUT_SELECT='INPUT_SELECT'
export const INPUT_SELECTSEARCH='INPUT_SELECTSEARCH'
export const INPUT_SELECTCHIPS='INPUT_SELECTCHIPS'
export const INPUT_DATE='INPUT_DATE'
export const INPUT_TEXTAREA='INPUT_TEXTAREA'


const transform_none = s => s
const transform_text = s => s.trim().toUpperCase()
const transform_email = s => s.trim().toLowerCase()
const transform_date = s => s.trim().replace(/\.+$/, '')
const transform_trim = s => s.trim()

const phone_clean = v => {
    v=v.replace(/[^+\d]/g,'')
    let v1=v.substr(0,1)
    let v2=v.substr(1).replace(/[^\d]/g,'')
    return v1+v2
}

const phone_transform = value => {
    return value.replace(/^8/,'+7').replace(/^(9\d{9})$/,'+7$1').replace(/^([0-7])/, '+$1')
}

const transform_phone = s => {
    s = phone_clean(s)
    s = phone_transform(s)
    return s
}

const phone_format = v => {
    const a=[]
//        +7 999 000 2222
    a.push(v.substring(0,2))
    a.push(v.substring(2,5))
    a.push(v.substring(5,8))
    a.push(v.substring(8))
    let b=a.filter( chunk => chunk.length ? true : false )
//console.log('_format', v, b)
    return b.join(' ')
}



const FNAME={
    type: INPUT_TEXT,
    name: 'fname',
    title: 'Фамилия',
    options: [], // не определено для текст
    placeholder: 'Иванов',
    transform: transform_text,
    default: '',
}
const INAME={ 
    ...FNAME, 
    name: 'iname',
    title: 'Имя',
    placeholder: 'Иван',
}
const ONAME={ 
    ...FNAME, 
    name: 'oname',
    title: 'Отчество',
    placeholder: 'Иванович',
}

const FLNAME = {
    ...FNAME,
    name: 'flname',
    title: 'Фамилия (лат)',
    placeholder: 'Ivanov',
}
const ILNAME = {
    ...FNAME,
    name: 'ilname',
    title: 'Имя (лат)',
    placeholder: 'Ivan',
}


const DOC_SERIE={
    type: INPUT_TEXT,
    name: 'doc_serie',
    title: 'Серия',
    options: [], // не определено для текст
    placeholder: '9999',
    transform: transform_text,
    default: '',
}
const DOC_NUMBER={
    type: INPUT_TEXT,
    name: 'doc_number',
    title: 'Номер',
    options: [], // не определено для текст
    placeholder: '999999',
    transform: transform_text,
    default: '',
}

const EMAIL={
    type: INPUT_TEXT,
    name: 'email',
    title: 'Емейл',
    options: [], // не определено для текст
    placeholder: 'some@email',
    transform: transform_email,
    usemask: {
        mask : /^[a-z0-9_\-\.\+]*@?[a-z0-9_\-\.]*$/, // /^[a-z0-9_\-\.\+]+@[a-z0-9_\-\.]+$/,
        lazy: true,
        overwrite: false,
    },
    default: '',
}
const NOTE={
    type: INPUT_TEXTAREA,
    name: 'note',
    title: 'Примечания',
    options: [], // не определено для текст
    placeholder: '',
    transform: transform_trim,
    default: '',
}

const DOC_ADDRESS = {
    type: INPUT_TEXT,
    name: 'doc_address',
    title: 'Адрес',
    placeholder: 'г Ивановск, Ленина 11-222',
    transform: transform_trim,
    options: [], // не определено для текст
    default: '',
}
const DOC_ZIP = {
    type: INPUT_TEXT,
    name: 'doc_zip',
    title: 'Почтовый индекс',
    placeholder: '620001',
    transform: transform_trim,
    options: [], // не определено для текст
    default: '',
}


const DOC_UNITCODE = {
    ...DOC_ADDRESS,
    name: 'doc_unitcode',
    title: 'Код подразделения',
    placeholder: '123-123',
    usemask: {
        mask : "000-000",
        lazy: true,
        overwrite: false,
    },
}

const DOC_AUTHORITY = {
    ...DOC_ADDRESS,
    name: 'doc_authority',
    title: 'Выдан',
    placeholder: 'ОМ ИВАНОВСКОГО РУВД Г ИВАНОВСКА',
}


const PHONE={
    type: INPUT_TEXT,
    name: 'phone',
    title: 'Телефон',
    options: [], // не определено для текст
    placeholder: '+7 999 111 22 33',
    transform: transform_phone,
    format: phone_format,
    default: '',
    usemask: {
        mask : "{+7} 000 000 00 00",
        lazy: true,
        overwrite: false,
    },
}


const MALE={
    type: INPUT_SELECTCHIPS,
    name: 'male',
    title: 'Пол',
    options: [
        {id:'m', name: 'Мужской'},
        {id:'f', name: 'Женский'},
    ],
    placeholder: '',
    transform: transform_none,
    default: '',
}
const DOC_GRA={
    type: INPUT_SELECTSEARCH,
    name: 'doc_gra',
    title: 'Гражданство',
    options: country_a2,
    placeholder: '',
    transform: transform_none,
    default: 'RU',
}
const ROOM = {
    type: INPUT_SELECT,
    name: 'room',
    title: 'каюта',
    options: [],
    options_getter: 'room_options',// в store должен существовать и быть публичным getter c этим именем
    use_getter: true, // в init должны задать getter для поля
    placeholder: 'каюта',
    transform: transform_none,
    default: '',
}
//INFANT_PARENT - пока пропускаем

const DOC_TYPE={
    type: INPUT_SELECT,
    name: 'doc_type',
    title: 'Документ',
    options: [
        {id:'ps', name: 'Паспорт РФ', tb: '2'},
        {id:'svr', name: 'Свидетельство о рождении РФ', tb: '3'},
        {id:'zps', name: 'Заграничный паспорт РФ', tb: '1'},
        {id:'other', name: 'Другой документ', tb: '4'},
    ],
    placeholder: '',
    transform: transform_none,
    default: '',
}
export const DOC_TYPE_OPTIONS = DOC_TYPE.options

const DOC_ISSUE={
    type: INPUT_DATE,
    name: 'doc_issue',
    title: 'Дата выдачи',
    options: [], // не определено для текст
    placeholder: '31.01.9999',
    transform: transform_date,
    default: '',
}

const DOC_VALID={
    type: INPUT_DATE,
    name: 'doc_valid',
    title: 'Действителен до',
    options: [], // не определено для текст
    placeholder: '31.01.9999',
    transform: transform_date,
    default: '',
}


const BORN={
    type: INPUT_DATE,
    name: 'born',
    title: 'Дата рождения',
    options: [], // не определено для текст
    placeholder: '31.01.9999',
    transform: transform_date,
    default: '',
}

export const SID_CUSTOMER = 'cust'

export default defineStore('tourist', () => {
    const pers = ref([])
    const customer = ref({})
    const rooms = ref([])
    const add_buttons = ref([])
    const localstor_save = reactive({
        key: '', // в этот ключ сохранять
        delay: 100, // с задержкой 100ms
        timeout: null, // тут задержка
    })
    let loaded = false


    const touched_sid = ref({})

    const touch = sid => {
        const old = unref(touched_sid)
        touched_sid.value = {...old, [sid]:true}
    }
    const untouch = sid => {
        const old = unref(touched_sid)
        touched_sid.value = {...old, [sid]:false}
    }

    const wasTouched = sid => {
        const old = unref(touched_sid)
        const ret = Boolean( old[sid] )
        return ret
    }


    const init = (store_type)=> {
        if (TOURIST.INITED) {
            if (TOURIST.INITED !== store_type) {
                const err=new Error('store init, store_type отличается') // ошибка при разработке
                console.error(err)
                throw err
            }
            return
        }
        if (TSTORE_TYPE_CRUISE === store_type) {
            TOURIST.FIELDS=[ 
                FNAME, INAME, ONAME, FLNAME, ILNAME, MALE, BORN, 
                DOC_GRA, DOC_TYPE, DOC_SERIE, DOC_NUMBER, DOC_ISSUE, DOC_VALID
            ]
            TOURIST.FIELDS_CUSTOMER = [ 
                FNAME, INAME, ONAME, FLNAME, ILNAME, MALE, BORN, 
                DOC_GRA, DOC_TYPE, DOC_SERIE, DOC_NUMBER, DOC_ISSUE, DOC_VALID,
                PHONE, EMAIL, 

                DOC_ADDRESS, DOC_UNITCODE, DOC_AUTHORITY, 

                NOTE, DOC_ZIP,
            ]
            TOURIST.NAME=TURISTNAME.passazhir
            TOURIST.INITED = store_type
/*
            при бронировании я буду передавть
            CRUISE_ADULT для passenger_type=0 - взрослое, у нас это - STATUS_ADL=1
            CRUISE_CHILD для passenger_type=2 - для ребенка с местом, у нас это - STATUS_CHD=2
            CRUISE_INFANT для passenger_type=1 - для ребенка без места, у нас это - STATUS_INF=3
            В этом случае я буду передавать INFANT_PARENT - номер туриста к которому прикреплен инфант

            тип будет прикреплен к туристу при создании
*/                

            TOURIST.TYPES = [  CRUISE_PLACE,  CRUISE_INFANT  ]
            add_buttons.value = TOURIST.TYPES.map( ({id, name}) => { return {id, name} }  )
            init_cust()
        }
    }

    const room_options = computed( ()=>{
        return [ {id:'', name: ROOM.placeholder}, ...rooms.value ]
    } )

    const person_vals = (person) => {
        const sid = person.sid
        const isCust = SID_CUSTOMER === sid 
        const FIELDS = isCust ? TOURIST.FIELDS_CUSTOMER : TOURIST.FIELDS
        const all = FIELDS.map( ({name}) => {
            return [ name, person[ name ].val ]
        } )
        if (!isCust) {
            all.push( ['tt', person.tt.id ] )
        } else {
            all.push( ['tt', CRUISE_ADULT.id ] )
        }
        all.push( ['isCust', isCust ] )
        const ret = Object.fromEntries( all )
        return ret
    }

    const init_pers = (persvals = null, newsid = null) => {
        const sid = newsid ? newsid : create_id()
        const all = TOURIST.FIELDS.map( ob => {
            const nov={...ob}
            let val = ob.default 
            if (persvals) {
                let val1 = persvals[ ob.name ]
                if ("string" === typeof(val1)) {
                    val = val1
                }
            }
            nov.val = val
            nov.sid = sid
            return [ob.name, nov]
        } )
        const isCust = false
        const allob = Object.fromEntries( all )
        return { sid, ...allob, isCust }
    }

    const init_cust = ( cust = null ) => {
        const sid = SID_CUSTOMER
        const all = TOURIST.FIELDS_CUSTOMER.map( ob => {
            const nov={...ob}
            let val = ob.default 
            if (cust) {
                let val1 = cust[ ob.name ]
                if ("string" === typeof(val1)) {
                    val = val1
                }
            }
            nov.val = val
            nov.sid = sid
            return [ob.name, nov]
        } )
        const person = Object.fromEntries( all )
        person.sid = sid
        person.isCust = true
        person.version = Date.now()
        suite_init( sid, 'customer' )
        if (cust) {
            suite_setob( sid, null, person_vals(person) ) // хотим инициализировать все поля
        }
        person.vest =  suite_getres( sid )
        customer.value = person
    }

    const copy_person = ( from,  to, from_vals = null  ) => {
//console.log('tstore.copy_person from,  to, from_vals', from,  to, from_vals)
        if (!from && !from_vals) {
            console.error('copy_person', '!from && !from_vals')
            return
        }
        if (from === to) {
            console.error('copy_person', 'from === to')
            return
        }
        const isCust = to === SID_CUSTOMER
        const FIELDS = isCust ? TOURIST.FIELDS_CUSTOMER : TOURIST.FIELDS
        const to_person = isCust ? customer.value : pers.value.find( ob => ob.sid === to )

        const person_from = from ?  person( from ) : null
        const get_val = (name,def) => {
            let val
            if (from) { // старое store
                val = name in person_from ? person_from[name].val : def
            } else {// import
                val = name in from_vals ? from_vals[name] : def
            }
            return val
        }
        FIELDS.forEach(({ name, default: def }) => {
            const val = get_val(name, def)
            to_person[ name ].val = val
        })

        suite_setob(to, null, person_vals(to_person))
        to_person.vest = suite_getres(to)
        pers_save_localstor_delayed()
    }


    const add_person = (tt_id, persvals = null, toEnd=false) => {// по умолчанию добавляю в начало
        const pers0 = init_pers( persvals )
        const tt = TOURIST.TYPES.find( ob => ob.id === tt_id )
        const person = { ...pers0, tt}
        const sid = person.sid
        suite_init( sid )
        let person_vals1 = person_vals(person)
        if (persvals) {// если передаем значения, то инициализируем все поля
            suite_setob( sid, null, person_vals1 ) // если передаем значения, то инициализируем все поля
        } else {// если добавляем незаполненного туриста - то лишь поля с выставленными значениями
            suite_setob( sid, 'doc_gra', person_vals1 ) // иначе Россия не выставится
        }
        person.vest=suite_getres( sid )
        if (toEnd) {
            pers.value.push( person )
        } else {
            pers.value.unshift( person )
        }
        pers_save_localstor_delayed()
        return sid
    }
    const del_person = tt_id => {
        let todel =  findLast(pers.value, person => person.tt.id === tt_id )
        if (todel) {
            remove_person( todel.sid )
        }
    }
    const clean = () => {
        pers.value = []
        init_cust()
        pers_save_localstor_delayed(true)
    }

    const remove_person = (sid,skip=false)  => {
        suite_remove( sid )
        pers.value = pers.value.filter( person => person.sid !== sid )
        if (!skip) {
            pers_save_localstor_delayed()
        }
    }

    const set_field = ( sid, ff, val ) => {
        const isCust = SID_CUSTOMER === sid 
        const person = isCust ? customer.value : pers.value.find( ob => ob.sid === sid )
/*
if (!person || !(ff in person)) {
    console.log('set_field', sid, ff)
}
*/
        const field = person[ ff ]
        if (val !== field.val) {
            const transval = field.transform( val )
            field.val = transval
            suite_setob( sid, ff, person_vals(person) ) 
            person.vest = suite_getres( sid ) // обновляем массив с ошибочками
            pers_save_localstor_delayed()
        }
    }
    const touch_all_fields = () => {// при нажатии на проверить - считаем, что чел все заполнил и хотим подсветить ВСЕ
        let all = pers.value.concat( [ customer.value ] )
        all.forEach( person => {
            let sid = person.sid
            suite_setob( sid, null, person_vals(person) ) 
            person.vest = suite_getres( sid )
        } )
    }


    const set_rooms = (list) => {
        rooms.value = list
        const room_count = list.length
        pers.value.forEach( ({room}) => {
            let num = room.val === "" ? -1 : Number( room.val )
            if (1 === room_count) { // если каюта одна - сразу выбираем
                set_field( room.sid, 'room', '0' )
            } else if (num >= room_count) { // в новом списке кают такой каюты нет
                set_field( room.sid, 'room', '' )
            }
        })
    }

    const kolvo = computed( () =>{
        let entries = add_buttons.value.map( ({id}) => { return [id, 0]  } )
        let start = Object.fromEntries( entries )
        let ret = pers.value.reduce ( (ob, {tt}) => {
            let prev = tt.id in ob ? ob[ tt.id ] : 0
            ob[ tt.id ] = prev + 1
            return ob
        }, start)
        return ret
    })



    const setLSkey = (lockey)=>{
        localstor_save.key = lockey
    }

    const pers_save_localstor = (lockey)=>{
        if (!lockey) {
            return
        }
        const tourist = pers.value.map( person => {
            const vals  = person_vals( person )
            const {sid} = person
            const ret = {sid, ...vals}
            return ret
        } )
        const cust = person_vals(customer.value)
        const vals = {tourist, cust}
        save_localStorage( lockey,  vals )
    }

    const pers_save_localstor_delayed = (immediate = false) => {
        const { key, delay, timeout } =  localstor_save
        if (timeout) {
            clearTimeout( timeout )
            localstor_save.timeout = null
        }
        if (!key) {// оставляем возможность прекратить перманентную регистрацию
            return
        }
        if (!immediate) {// только добавляем
            localstor_save.timeout = setTimeout( pers_save_localstor_delayed, delay, true) // ставим immediate
        } else {
            localstor_save.timeout = null
            pers_save_localstor( key )
        }
    }


    const tostr = (s) => {
        return 'string' === typeof(s) ? s : ''
    }

    const cleanEmpty = ( sidsob ) => {
        unref(pers).forEach( person => {
            const {sid} = person
            if (!(sid in sidsob) && emptyPerson(person) ) {
                remove_person(sid, true)
            } 
        } ) 
    }

    const emptyPerson = (person) => {
        let ret = 
            !person.fname.val && !person.iname.val
            && !person.flname.val && !person.ilname.val
        return ret
    }


    const pers_load_localstor = (lockey) => {
        if (loaded) {
            return
        }
        let vals=[]
        let cust = null
        try {
            const str = window.localStorage.getItem( lockey )
            if (str) {
                let all = JSON.parse( str )
                vals = all.tourist
                cust = all.cust 
            }
        } catch (e) {
            console.error('pers_load_localstor', e)
        }
        loaded = true
//console.log('pers_load_localstor', vals)
        if (cust && 'email' in cust) {
            init_cust( cust )
        }
        if (Array.isArray(vals) && vals.length>0) {
            pers.value=[]
            vals.forEach( pvals => {
                const {sid} = pvals
                if (!sid || 'string' !== typeof(sid)) {
                    console.error('no sid', pvals)
                    return
                }
                const pers0 = init_pers(null, sid)
                let tt = TOURIST.TYPES.find( ob => ob.id === pvals.tt )
                if (!tt) {
                    tt = pvals.tt == 'cr-infant' ? CRUISE_INFANT : CRUISE_PLACE
//                    console.error('no tt', pvals)
//                    return
                }
                const person = { ...pers0, tt}
                TOURIST.FIELDS.forEach( ({name, type, options, use_getter, options_getter })=>{
                    const val = pvals[name] 
                    if ("string" !== typeof(val)) { // только string храним
                        return;
                    }
                    if ([INPUT_TEXT, INPUT_DATE].includes(type)) {
                        person[name].val = val
                    } else if ([INPUT_SELECT, INPUT_SELECTSEARCH, INPUT_SELECTCHIPS].includes(type)) {
                        let list = !use_getter ? options : []
                        if (use_getter) {// выполним set_rooms
                            person[name].val = val
                        } else if ( list.find( opt => opt.id === val )) {// нашли среди опций
                            person[name].val = val
                        }
                    }
                })

                remove_person(sid, true)
                suite_init( sid )
                suite_setob( sid, null, person_vals(person) ) // хотим инициализировать все поля
                person.vest=suite_getres( sid )
                pers.value.push( person )
            })
        }
    }

    const person = sid => {
        let ret
        if (SID_CUSTOMER === sid) {
            ret = unref(customer)
        } else {
            ret = unref(pers).find( p => sid === p.sid )
        }
        return ret
    }

    const isCustomer = sid => {
        return Boolean(SID_CUSTOMER === sid)
    }

    const clear_person = (sid) => {
        const isCust = SID_CUSTOMER === sid
        const person = isCust
            ? customer.value
            : pers.value.find(p => p.sid === sid)

        if (!person) return

        const FIELDS = isCust
            ? TOURIST.FIELDS_CUSTOMER
            : TOURIST.FIELDS

        FIELDS.forEach(({ name, default: def }) => {
            set_field(sid, name, def ?? '')
        })

        suite_setob(sid, null, person_vals(person))
        person.vest = suite_getres(sid)

        untouch(sid)

        pers_save_localstor_delayed()
    }

    const field_isValid = (person, field_name) => {
        let rec =  person.vest.tests[ field_name ]
//console.log('field_isValid', rec, person.vest,  field_name )
        return rec.valid
    }

    return {
        cleanEmpty, isCustomer,
        person, init, pers, 
        add_buttons, add_person, init_cust, del_person, remove_person, set_field, 
        set_rooms, room_options, rooms,
        pers_load_localstor, 
        pers_save_localstor, 
        setLSkey, 
        customer,  touch_all_fields, kolvo, clean,
        TOURIST, DOC_TYPE_OPTIONS,
        clear_person,
        field_isValid,
        copy_person,
        touch,
        wasTouched,
        untouch,
    } 
})
